import $ from 'jquery';

export default class LanguageSwitcher {
    constructor() {
        $('.js-language-switcher__toggle').on('click', function() {
            $(this).toggleClass('is-active');

            $('.js-language-switcher__langs:not(.is-active)').toggle();
        });
    };
};
